import { ValidationErrors, ValidatorFn, AbstractControl } from "@angular/forms";

export const fiscalCodeValidation: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  let regex = new RegExp("^[a-zA-Z0-9]+$");
  if (control.value == "") {
    return null;
  }

  const fiscal_code_capital = control.value.toUpperCase();
  const fiscal_code_segmented = fiscal_code_capital.split("-");
  if (fiscal_code_segmented.length == 5) {
    for (let segment of fiscal_code_segmented) {
      if (!regex.test(segment)) {
        return { invalidFiscalcode: true };
      }
    }
    return null;
  }
  return { invalidFiscalcode: true };
};
